import { render, staticRenderFns } from "./CourseGradesTable.vue?vue&type=template&id=5d4f23fa&scoped=true&"
import script from "./CourseGradesTable.vue?vue&type=script&lang=js&"
export * from "./CourseGradesTable.vue?vue&type=script&lang=js&"
import style0 from "./CourseGradesTable.vue?vue&type=style&index=0&id=5d4f23fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f23fa",
  null
  
)

export default component.exports